import { LifeBuoy } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { ToolPart } from "./tool-approvals.ts";

/**
 * One `product_help` call in the answer's activity (openspec change `agent-self-knowledge-help`):
 * the query and the help pages it returned, by title. Internal: nothing left ESI, so no
 * outbound row, arguments block or confirmation.
 */
export function HelpSearchRow({ part }: { part: ToolPart }) {
  const { t } = useTranslation();
  const query = (part.input as { query?: unknown } | undefined)?.query;
  const results = (part.output as { results?: { title?: unknown }[] } | undefined)?.results;
  const titles = [
    ...new Set(
      (Array.isArray(results) ? results : [])
        .map((r) => r?.title)
        .filter((title): title is string => typeof title === "string"),
    ),
  ];
  const done = part.state === "output-available";
  return (
    <div className="flex flex-col gap-0.5 py-1 text-xs text-fg-muted">
      <p className="flex min-w-0 items-center gap-1.5">
        <LifeBuoy aria-hidden="true" className="size-3 shrink-0" strokeWidth={2} />
        <span className="font-medium text-fg-secondary">
          {done ? t("tools.help.searched") : t("tools.help.searching")}
        </span>
        {typeof query === "string" ? <span className="min-w-0 truncate">“{query}”</span> : null}
      </p>
      {done && titles.length > 0 ? (
        <p className="ps-[1.125rem]">
          <span className="sr-only">{t("tools.help.pages", { count: titles.length })}: </span>
          {titles.join(" · ")}
        </p>
      ) : null}
    </div>
  );
}
